export default {
  noActiveJob: 'Nie znaleziono aktywnych zadań',
  pinnedSensorModalHeader: 'Wybierz przypięte czujniki',
  pinnedSensorListHeadline: 'Przypięte czujniki',
  jobTableHeader: 'Aktywne zadania w wybranym przedziale czasowym',
};
